jQuery(document).ready(function($) {
	$(".esg-article-slider-wrapper").each(function() {
        const slickData = {
			dots: true,
			infinite: false,
			vertical: false,
			arrows: true,
			prevArrow: $(this).closest(".esg-article-slider").find(".prev-slide"),
			nextArrow: $(this).closest(".esg-article-slider").find(".next-slide"),
			speed: 300,
			centerMode: true,
			slidesToShow: 5,
			slidesToScroll: 5,
			focusOnSelect: true,
			draggable: true,
			variableWidth: true,
			swipeToSlide: true,
			initialSlide: window.innerWidth > 1040 ? 2 : 0,
        }

		slickData.appendDots = $(this).closest(".esg-article-slider").find(".dots-wrapper");
		$(this).slick(slickData);
	});
});
